(function () {
  function init(root) {
    if (root.dataset.bhReady) return;
    root.dataset.bhReady = '1';
    var faces = root.querySelectorAll('[data-bh-face]');
    var dots = root.querySelectorAll('[data-bh-dot]');
    var current = 0, timer = null;
    var ms = (parseInt(root.getAttribute('data-bh-cycle'), 10) || 4) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(i) {
      current = (i + faces.length) % faces.length;
      faces.forEach(function (f, n) { f.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { if (n === current) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); } });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (reduce || faces.length < 2) return; stop(); timer = setInterval(function () { show(current + 1); }, ms); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-bh-dot'), 10)); stop(); }); });
    var stage = root.querySelector('.bh-stage');
    if (stage) { stage.addEventListener('mouseenter', stop); stage.addEventListener('mouseleave', start); stage.addEventListener('focusin', stop); }
    start();
    var cd = root.querySelector('[data-bh-end]');
    if (cd) {
      var end = new Date(cd.getAttribute('data-bh-end')).getTime();
      if (!isNaN(end)) {
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        var tick = function () {
          var left = end - Date.now();
          if (left <= 0) { cd.hidden = true; return false; }
          var d = Math.floor(left / 86400000), h = Math.floor(left / 3600000) % 24, m = Math.floor(left / 60000) % 60, s = Math.floor(left / 1000) % 60;
          cd.textContent = 'Ends in ' + (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm' + (d > 0 ? '' : ' ' + pad(s) + 's');
          cd.hidden = false;
          return true;
        };
        if (tick()) { setInterval(tick, 1000); }
      }
    }
  }
  function boot() { document.querySelectorAll('.bogo-hero').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();